import { render, staticRenderFns } from "./Partial-menu.vue?vue&type=template&id=1cabe2ef&scoped=true"
import script from "./Partial-menu.vue?vue&type=script&lang=js"
export * from "./Partial-menu.vue?vue&type=script&lang=js"
import style0 from "./Partial-menu.vue?vue&type=style&index=0&id=1cabe2ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cabe2ef",
  null
  
)

export default component.exports